@if (controlModel) {
    @if (isLoading) {
        <div class="fancy-loader"></div>
    } @else {
        <datamanagement-linkable
            #linkableProcessingPurpose
            typename="data processing"
            displayValueProp="name"
            [linked]="linked"
            [unlinked]="unlinked"
            [orderByValueProperty]="true"
            [disabled]="disabled"
            (linkedChange)="linkedItemsChanged($event)"
        >
        </datamanagement-linkable>
    }
}
